import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

import React from 'react';

import styles from './ModalEle.module.scss';

const { borderColor, scrollBarTrack, scrollBar } = styles;

interface IModalProps {
	open: boolean;
	handleClose?: () => void;
	children: React.ReactNode;
	sxProps?: any;
	sxBoxProps?: any;
	restrictDefaultCloseAction?: boolean;
	dataTestId?: string;
}
const style = {
	outline: 'none',
	position: 'absolute' as const,
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '50vw',
	maxHeight: '95%',
	bgcolor: 'background.paper',
	border: `1 solid ${borderColor}`,
	borderRadius: '10px',
	boxShadow: 'none',
	paddingTop: 2,
	paddingBottom: 3,
	paddingLeft: 4,
	paddingRight: 4,
	overflowY: 'auto',
	overflowX: 'hidden',
	'&::-webkit-scrollbar': {
		width: '0.4em',
	},
	'&::-webkit-scrollbar-track': {
		background: scrollBarTrack,
	},
	'&::-webkit-scrollbar-thumb': {
		backgroundColor: scrollBar,
	},
	'&::-webkit-scrollbar-thumb:hover': {
		background: scrollBarTrack,
	},
};
const ModalEle = (props: IModalProps) => {
	const {
		open,
		handleClose,
		children,
		sxProps,
		sxBoxProps,
		restrictDefaultCloseAction,
		dataTestId,
	} = props;
	style.width = sxBoxProps?.width ? sxBoxProps.width : style.width;
	style.paddingRight = sxBoxProps?.paddingRight
		? sxBoxProps.paddingRight
		: style.paddingRight;
	style.paddingLeft = sxBoxProps?.paddingLeft
		? sxBoxProps.paddingLeft
		: style.paddingLeft;
	style.paddingBottom = sxBoxProps?.paddingBottom
		? sxBoxProps.paddingBottom
		: style.paddingBottom;
	style.maxHeight = sxBoxProps?.maxHeight || style.maxHeight;
	style.overflowX = sxBoxProps?.overflowX || style.overflowX;
	style.overflowY = sxBoxProps?.overflowY || style.overflowY;
	const getHandleClose = (reason: string) => {
		if (
			(restrictDefaultCloseAction &&
				reason !== 'backdropClick' &&
				handleClose) ||
			(!restrictDefaultCloseAction && handleClose)
		) {
			handleClose();
		}
	};
	return (
		<Modal
			data-testid={dataTestId}
			sx={sxProps}
			open={open}
			onClose={(_event, reason) => {
				getHandleClose(reason);
			}}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<Box sx={style}>{children}</Box>
		</Modal>
	);
};
export default ModalEle;
